import { Injectable } from '@angular/core'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class EmailRemindersService extends ApiService {
  unsubsribeFromEmailReminders(token: string, data?: { reason?: string; email?: string }) {
    return this.patch(`${this.apiUrl}/email-reminders/unsubscribe/${token}`, data)
  }

  getReminderTypeByToken(token: string) {
    return this.get(`${this.apiUrl}/email-reminders/get-type/${token}`)
  }
}
